<!-- 论文归档资料 -->
<template>
  <svg v-if="modelValue == 0" class="notStarted" viewBox="0 0 35.2 36.38">
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="27.78" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="27.78" rx="13.61" ry="6.79" />
        <path
          class="cls-3"
          d="M30.39,5.39V3.91a2.66,2.66,0,0,0-2.45-2.82H7.6A2.66,2.66,0,0,0,5.14,3.91V21.24A2.66,2.66,0,0,0,7.6,24.06H27.94a2.66,2.66,0,0,0,2.45-2.82V13.51"
        />
        <line class="cls-3" x1="9.13" y1="28.34" x2="26.4" y2="28.34" />
        <path
          class="cls-3"
          d="M24.93,6.75l-5.59,6.88a.49.49,0,0,1-.7.07l-3.52-3.09a.49.49,0,0,0-.73.09L9.57,17.6"
        />
        <ellipse class="cls-4" cx="30.6" cy="8.94" rx="1.44" ry="1.36" />
      </g>
    </g>
  </svg>
  <svg v-else-if="modelValue == 1" class="inProgress" viewBox="0 0 35.2 36.21">
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="27.61" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="27.61" rx="13.61" ry="6.79" />
        <path
          class="cls-3"
          d="M30.29,5.3V3.84a2.61,2.61,0,0,0-2.41-2.77h-20A2.61,2.61,0,0,0,5.45,3.84V20.9a2.61,2.61,0,0,0,2.41,2.77h20a2.61,2.61,0,0,0,2.41-2.77V13.29"
        />
        <line class="cls-3" x1="9.38" y1="27.89" x2="26.37" y2="27.89" />
        <path
          class="cls-3"
          d="M24.92,6.64l-5.51,6.78a.47.47,0,0,1-.68.06l-3.47-3a.48.48,0,0,0-.71.09L9.81,17.32"
        />
        <ellipse class="cls-4" cx="30.5" cy="8.8" rx="1.42" ry="1.33" />
      </g>
    </g>
  </svg>
  <svg v-else viewBox="0 0 35.12 31.76">
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.56" cy="23.18" rx="17.56" ry="8.58" />
        <ellipse class="cls-2" cx="17.56" cy="23.18" rx="13.58" ry="6.78" />
        <path
          class="cls-3"
          d="M27.79,4.62V3.36A2.25,2.25,0,0,0,25.71,1H8.47A2.25,2.25,0,0,0,6.39,3.36V18.05a2.25,2.25,0,0,0,2.08,2.39H25.71a2.25,2.25,0,0,0,2.08-2.39V11.5"
        />
        <line class="cls-3" x1="9.77" y1="24.07" x2="24.4" y2="24.07" />
        <path
          class="cls-3"
          d="M23.16,5.77,18.42,11.6a.41.41,0,0,1-.6.06L14.84,9a.4.4,0,0,0-.61.08L10.14,15"
        />
        <ellipse class="cls-4" cx="27.79" cy="7.57" rx="0.94" ry="1.04" />
      </g>
    </g>
  </svg>
</template>
<script lang="ts" setup>
  withDefaults(
    defineProps<{
      /** 任务执行状态 */
      modelValue: number;
    }>(),
    // 默认值
    { modelValue: 0 }
  );
</script>
<style lang="scss" scoped>
  // 未开始
  .notStarted {
    .cls-1 {
      fill: #f0f7f7;
    }
    .cls-2 {
      fill: #d7e2e2;
    }
    .cls-3 {
      fill: none;
      stroke: #9a9b9b;
      stroke-linecap: round;
      stroke-miterlimit: 10;
      stroke-width: 2.17px;
    }
    .cls-4 {
      fill: #9a9b9b;
    }
  }
  //进行中
  .inProgress {
    .cls-1 {
      fill: #f4e4d4;
    }
    .cls-2 {
      fill: #efd0a3;
    }
    .cls-3 {
      fill: none;
      stroke: #ed9c24;
      stroke-linecap: round;
      stroke-miterlimit: 10;
      stroke-width: 2.14px;
    }
    .cls-4 {
      fill: #ed9c24;
    }
  }
  // 已完成
  .completed {
    .cls-1 {
      fill: #d5ebe9;
    }
    .cls-2 {
      fill: #b8ded9;
    }
    .cls-3 {
      fill: none;
      stroke-linecap: round;
      stroke-width: 1.94px;
    }
    .cls-3,
    .cls-4 {
      stroke: #26a98c;
      stroke-miterlimit: 10;
    }
    .cls-4 {
      fill: #26a98c;
      stroke-width: 0.48px;
    }
  }
</style>
